import { render, staticRenderFns } from "./ProceduresPage.vue?vue&type=template&id=d5595e20&scoped=true"
import script from "./ProceduresPage.vue?vue&type=script&lang=js"
export * from "./ProceduresPage.vue?vue&type=script&lang=js"
import style0 from "./ProceduresPage.vue?vue&type=style&index=0&id=d5595e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5595e20",
  null
  
)

export default component.exports